if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}

export default class HtmlHelper {
    static createElement(htmlString) {
        if (htmlString.indexOf('<html') !== -1) {
            throw new Error('Trying to create element from the complete html page. Partial html is required');
        }

        const template = document.createElement('template');
        template.innerHTML = htmlString.trim();
        const element = template.content ? template.content.firstChild : template.firstChild;
        // move element to current document to avoid bugs later when we insert it to DOM
        document.adoptNode(element);
        return element;
    }

    static safeAddEventListener(element) {
        if (element) {
            const args = [...arguments].slice(1);
            element.addEventListener(...args);
        }
    }

    static hasElementParentWithSelector(target, selector, includeSelf = true, root) {
        return this.getParent(target, selector, includeSelf, root) !== null;
    }

    static getParent(target, selector, includeSelf = true, root = document.body) {
        if (includeSelf && target.matches(selector)) {
            return target;
        }

        let parent = target.parentElement;

        while (parent && parent !== root) {
            if (parent.matches(selector)) {
                return parent;
            }
            parent = parent.parentElement;
        }

        return null;
    }

    static isHtmlElement(element) {
        return typeof element === 'object' && ('nodeType' in element);
    }

    static getTitleFromPopupHtml(html) {
        const contentElement = HtmlHelper.createElement(html);
        let result = '';

        const metaDataValue = contentElement.getAttribute('data-meta');
        if (metaDataValue) {
            try {
                const metaData = JSON.parse(metaDataValue);
                if (metaData.title) {
                    result = metaData.title;
                }
            } catch (e) {
                console.error(e);
            }
        }

        return result;
    }

    static modifySocialElementsStyleFromPopupHtml(html) {
        const htmlToModify = '<div>' + html + '</div>';
        const contentElement = HtmlHelper.createElement(htmlToModify);

        const socialFacebook = contentElement.querySelector('#social-facebook');
        const socialTwitter = contentElement.querySelector('#social-twitter');
        const acceptFunctionalCookiesWarning = contentElement.querySelector('#accept-functional-cookies');

        if (socialFacebook && socialTwitter && acceptFunctionalCookiesWarning) {
            return HtmlHelper.changeStyleHelper(socialFacebook, socialTwitter,
                acceptFunctionalCookiesWarning, contentElement);
        }
        return html;
    }

    static changeStyleHelper(socialFacebook, socialTwitter,
        acceptFunctionalCookiesWarning, contentElement) {
        const cookie = document.cookie;
        const canDisplay = cookie.includes('"FunctionalCookies":"accepted"');
        if (canDisplay) {
            socialFacebook.style.display = 'block';
            socialTwitter.style.display = 'block';
            acceptFunctionalCookiesWarning.style.display = 'none';
        } else {
            socialFacebook.style.display = 'none';
            socialTwitter.style.display = 'none';
            acceptFunctionalCookiesWarning.style.display = 'block';
        }

        return contentElement.innerHTML;
    }

    static getLastNodeOfTypeFromDom(selector) {
        const nodeList = document.querySelectorAll(selector);

        if (nodeList.length) {
            return nodeList[nodeList.length - 1];
        }

        return null;
    }

    static removeElementsFromDom(selector) {
        const nodeList = document.querySelectorAll(selector);

        if (nodeList.length) {
            nodeList.forEach((node) => {
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            });
        }
    }
}
